import type { chat as en } from '../en/chat';

export const chat: Record<keyof typeof en, string> = {
  // CallSummary
  'chat.call.today': 'आज, {time}',
  'chat.call.yesterday': 'कल, {time}',
  'chat.call.seconds': '{n} सेकंड',
  'chat.call.minutes': '{n} मिनट',
  'chat.call.voiceDuration': 'वॉइस कॉल · {duration}',
  'chat.call.videoDuration': 'वीडियो कॉल · {duration}',
  'chat.call.missedVoice': 'छूटी हुई वॉइस कॉल',
  'chat.call.missedVideo': 'छूटी हुई वीडियो कॉल',
  'chat.call.declined': 'कॉल नहीं उठाई गई',
  'chat.call.youDeclined': 'आपने कॉल नहीं उठाई',
  'chat.call.youCancelled': 'आपने कॉल काट दी',
  'chat.call.noAnswer': 'किसी ने नहीं उठाई',
  'chat.call.missed': 'छूटी हुई',
  'chat.call.missedNotice': 'यह कॉल छूट गई',
  'chat.call.callBack': 'वापस कॉल करें',
  // ChatHeader
  'chat.header.typingOne': '{name} लिख रहे हैं…',
  'chat.header.typingTwo': '{first} और {second} लिख रहे हैं…',
  'chat.header.typingMany': 'कई लोग लिख रहे हैं…',
  'chat.header.unmute': 'इस चैट की सूचनाएँ चालू करें',
  'chat.header.mute': 'इस चैट की सूचनाएँ बंद करें',
  'chat.header.everyone': 'सब लोग',
  'chat.header.people': '{n} लोग',
  'chat.header.back': 'चैट पर वापस',
  'chat.header.search': 'इस चैट में खोजें',
  'chat.header.voiceCall': 'वॉइस कॉल',
  'chat.header.videoCall': 'वीडियो कॉल',
  'chat.header.more': 'चैट के और विकल्प',
  'chat.header.groupSettings': 'ग्रुप की जानकारी',
  'chat.header.whatDoYouCall': 'आप {name} को क्या कहते हैं?',
  'chat.header.securityCodes': 'सुरक्षा कोड',
  // Report and block (M58, D207, D208)
  'chat.header.report': 'शिकायत करें…',
  'chat.header.block': '{name} को ब्लॉक करें',
  'chat.report.title': '{name} की शिकायत करें',
  'chat.report.reasonLabel': 'क्या ग़लत है?',
  'chat.report.reason.harassment': 'परेशान करना या गाली-गलौज',
  'chat.report.reason.spam': 'स्पैम या धोखा',
  'chat.report.reason.impersonation': 'किसी और होने का दिखावा',
  'chat.report.reason.other': 'कुछ और',
  'chat.report.chooseReason': 'कोई वजह चुनें',
  'chat.report.noteLabel': 'कुछ और बताना है? (ज़रूरी नहीं)',
  'chat.report.notePlaceholder': 'क्या हुआ',
  'chat.report.noteTooLong': 'नोट {max} अक्षरों तक रखें',
  'chat.report.alsoBlock': '{name} को ब्लॉक भी करें',
  'chat.report.alsoBlockHint':
    'वे आपको सीधे मैसेज या कॉल नहीं कर पाएँगे। परिवार के ग्रुप वैसे ही रहेंगे।',
  'chat.report.privacy':
    'Twinden आपके मैसेज नहीं पढ़ सकता, इसलिए शिकायत में बस यह होता है कि किसकी और क्यों, यह नहीं कि क्या कहा गया। इसे आपके परिवार के रूट और Twinden देखते हैं।',
  'chat.report.send': 'शिकायत भेजें',
  'chat.report.sent': 'शिकायत भेज दी गई। धन्यवाद।',
  'chat.report.failed': 'शिकायत नहीं भेजी जा सकी',
  'chat.block.title': '{name} को ब्लॉक करें?',
  'chat.block.body':
    'वे आपको सीधे मैसेज या कॉल नहीं कर पाएँगे, और उनके साथ आपकी चैट छिप जाएगी। उन्हें बताया नहीं जाएगा। परिवार के ग्रुप वैसे ही रहेंगे। आप सेटिंग्स में अनब्लॉक कर सकते हैं।',
  'chat.block.confirm': 'ब्लॉक करें',
  'chat.block.done': '{name} ब्लॉक हो गए',
  'chat.block.failed': 'ब्लॉक नहीं किया जा सका',
  'chat.reported.title': '{family} में किसी सदस्य की शिकायत हुई है',
  'chat.reported.hint': 'परिवार संभालें → शिकायतें में देखें।',
  // ConversationDialogs
  'chat.dialogs.groupCreated': 'ग्रुप बन गया',
  'chat.dialogs.couldNotCreateGroup': 'ग्रुप नहीं बन पाया',
  'chat.dialogs.newGroup': 'नया ग्रुप',
  'chat.dialogs.groupName': 'ग्रुप का नाम',
  'chat.dialogs.groupNamePlaceholder': 'जैसे, वीकेंड का प्लान',
  'chat.dialogs.members': 'सदस्य',
  'chat.dialogs.nobodyElse': 'इस परिवार में अभी और कोई नहीं है।',
  'chat.dialogs.createGroup': 'ग्रुप बनाएँ',
  'chat.dialogs.couldNotOpenChat': 'चैट नहीं खुल पाई',
  'chat.dialogs.newChat': 'नई चैट',
  'chat.dialogs.searchMembers': 'परिवार के सदस्य खोजें',
  'chat.dialogs.noMatch': 'ऐसा कोई सदस्य नहीं मिला।',
  'chat.dialogs.groupRenamed': 'ग्रुप का नाम बदल गया',
  'chat.dialogs.couldNotRename': 'ग्रुप का नाम नहीं बदल पाया',
  'chat.dialogs.membersAdded': 'सदस्य जुड़ गए',
  'chat.dialogs.couldNotAdd': 'सदस्य नहीं जुड़ पाए',
  'chat.dialogs.confirmRemove': 'इन्हें ग्रुप से हटाएँ?',
  'chat.dialogs.couldNotRemove': 'सदस्य को हटा नहीं पाए',
  'chat.dialogs.couldNotChangeRole': 'भूमिका नहीं बदल पाई',
  'chat.dialogs.confirmLeave': 'यह ग्रुप छोड़ें?',
  'chat.dialogs.leftGroup': 'आपने ग्रुप छोड़ दिया',
  'chat.dialogs.couldNotLeave': 'ग्रुप नहीं छोड़ पाए',
  'chat.dialogs.confirmDelete': 'यह ग्रुप सबके लिए मिटाएँ?',
  'chat.dialogs.groupDeleted': 'ग्रुप मिट गया',
  'chat.dialogs.couldNotDelete': 'ग्रुप नहीं मिट पाया',
  'chat.dialogs.name': 'नाम',
  'chat.dialogs.membersCount': 'सदस्य ({n})',
  'chat.dialogs.youSuffix': '(आप)',
  'chat.dialogs.admin': 'एडमिन',
  'chat.dialogs.demote': 'एडमिन से हटाएँ',
  'chat.dialogs.promote': 'एडमिन बनाएँ',
  'chat.dialogs.addMembers': 'परिवार के सदस्य जोड़ें',
  'chat.dialogs.addSelected': 'चुने हुए जोड़ें',
  'chat.dialogs.leave': 'छोड़ें',
  // ConversationList (home)
  'chat.home.sentPhoto': 'फ़ोटो भेजी',
  'chat.home.encrypted': 'एन्क्रिप्टेड संदेश',
  'chat.home.declinedVoice': 'वॉइस कॉल नहीं उठाई',
  'chat.home.declinedVideo': 'वीडियो कॉल नहीं उठाई',
  'chat.home.cancelledVoice': 'वॉइस कॉल काट दी',
  'chat.home.cancelledVideo': 'वीडियो कॉल काट दी',
  'chat.home.sentGif': 'GIF भेजा',
  'chat.home.sentVideo': 'वीडियो भेजा',
  'chat.home.sentVoice': 'वॉइस नोट भेजा',
  'chat.home.sentFile': 'फ़ाइल भेजी',
  'chat.home.sentThing': '{thing} भेजा',
  'chat.home.whoSentPhoto': '{name} ने फ़ोटो भेजी',
  'chat.home.whoSentGif': '{name} ने GIF भेजा',
  'chat.home.whoSentVideo': '{name} ने वीडियो भेजा',
  'chat.home.whoSentVoice': '{name} ने वॉइस नोट भेजा',
  'chat.home.whoSentFile': '{name} ने फ़ाइल भेजी',
  'chat.home.whoSentThing': '{name} ने {thing} भेजा',
  'chat.home.search': 'चैट और संदेश खोजें',
  'chat.home.family': 'परिवार',
  'chat.home.chatWith': '{name} से चैट करें',
  'chat.home.chatWithNew': '{name} से चैट करें, नए संदेश',
  'chat.home.myBirthday': 'जन्मदिन मुबारक! आपका दिन बहुत अच्छा हो।',
  'chat.home.festivalTouch': 'आज {name}',
  'chat.home.birthdayToday': 'आज {name} का जन्मदिन है',
  'chat.home.wishThem': 'बधाई दें',
  'chat.siblings.label': 'आपके भाई-बहनों के लिए त्योहार की शुभकामना',
  'chat.siblings.one': '{name} को {festival} की शुभकामना भेजें',
  'chat.siblings.many': '{festival} की शुभकामना भेजें',
  'chat.siblings.wish': 'शुभकामना भेजें',
  'chat.siblings.wishName': '{name} को {festival} की शुभकामना भेजें',
  'chat.siblings.dismiss': 'इस साल नहीं',
  'chat.home.mentionsOne': '1 नया मेंशन',
  'chat.home.mentionsOther': '{n} नए मेंशन',
  'chat.home.newCount': '{n} नए',
  'chat.home.muted': 'म्यूट है',
  'chat.home.helloEveryone': 'पूरे परिवार को नमस्ते कहें',
  'chat.home.unreadSuffix': ', {n} बिना पढ़े',
  'chat.home.mutedSuffix': ', म्यूट',
  'chat.home.hello': 'नमस्ते कहें',
  'chat.home.messages': 'संदेश',
  'chat.home.nothingMatches': '“{query}” से कुछ नहीं मिला',
  'chat.home.noChats': 'इस परिवार में अभी कोई चैट नहीं',
  // ConversationSearch
  'chat.unknown': 'अनजान',
  'chat.search.failed': 'खोज नहीं हो पाई',
  'chat.search.close': 'खोज बंद करें',
  'chat.search.noMatch': '“{query}” से कोई संदेश नहीं मिला',
  'chat.search.typeAtLeast': 'कम से कम {n} अक्षर लिखें',
  // DeleteMessageDialog
  'chat.message.deleted': 'यह संदेश मिटा दिया गया',
  'chat.delete.forMeBody': 'यह सिर्फ़ आपके लिए छिपेगा। बाकी सबको दिखता रहेगा।',
  'chat.delete.forEveryoneBody':
    'इस चैट में सबको “यह संदेश मिटा दिया गया” दिखेगा। यह वापस नहीं होगा।',
  'chat.delete.adminBody':
    'परिवार के एडमिन होने के नाते आप {name} का संदेश सबके लिए हटा सकते हैं; यह परिवार के ऑडिट लॉग में दर्ज होगा।',
  'chat.delete.adminBodyNoName':
    'परिवार के एडमिन होने के नाते आप यह संदेश सबके लिए हटा सकते हैं; यह परिवार के ऑडिट लॉग में दर्ज होगा।',
  'chat.delete.title': 'यह संदेश मिटाएँ?',
  'chat.delete.titleForMe': 'सिर्फ़ अपने लिए मिटाएँ?',
  'chat.delete.forEveryone': 'सबके लिए मिटाएँ',
  'chat.delete.forMe': 'मेरे लिए मिटाएँ',
  'chat.delete.keep': 'रहने दें',
  // FileCard
  'chat.file.badge': 'फ़ाइल',
  'chat.file.couldNotDownload': '{name} डाउनलोड नहीं हो पाई',
  'chat.file.downloading': '{name} डाउनलोड हो रही है',
  'chat.file.progress': '{total} में से {done}',
  'chat.file.starting': 'शुरू हो रहा है…',
  'chat.file.cancel': 'डाउनलोड रोकें',
  'chat.file.download': '{name} डाउनलोड करें',
  // ForwardDialog
  'chat.forward.title': 'फ़ॉरवर्ड करें',
  'chat.forward.selected': '{n}/{max} चुने',
  // GettingKeysNotice
  'chat.keys.getting': 'आपके दूसरे डिवाइस से संदेश आ रहे हैं…',
  'chat.keys.unlocked': 'आपके संदेश खुल गए',
  'chat.keys.hide': 'छिपाएँ',
  // GreetingSheet and occasion names (lib/greetings.ts)
  'chat.greeting.title': 'शुभकामना भेजें',
  'chat.greeting.pick': 'मौक़ा चुनें। भेजने से पहले आप शब्द बदल सकते हैं।',
  'chat.greeting.occasions': 'मौक़े',
  'chat.greeting.another': 'कोई और मौक़ा चुनें',
  'chat.greeting.card': '{name} का कार्ड',
  'chat.greeting.cardLabel': '{name} का कार्ड: {line}',
  'chat.greeting.yours': 'आपकी शुभकामना',
  'chat.greeting.send': 'कार्ड भेजें',
  'chat.greeting.diwali': 'दिवाली',
  'chat.greeting.holi': 'होली',
  'chat.greeting.rakshaBandhan': 'रक्षाबंधन',
  'chat.greeting.eid': 'ईद',
  'chat.greeting.christmas': 'क्रिसमस',
  'chat.greeting.pongal': 'पोंगल',
  'chat.greeting.onam': 'ओणम',
  'chat.greeting.navratri': 'नवरात्रि',
  'chat.greeting.lohri': 'लोहड़ी',
  'chat.greeting.karvaChauth': 'करवा चौथ',
  'chat.greeting.durgaPuja': 'दुर्गा पूजा',
  'chat.greeting.newYear': 'नया साल',
  'chat.greeting.birthday': 'जन्मदिन',
  'chat.greeting.anniversary': 'सालगिरह',
  'chat.greeting.eidAlAdha': 'बक़रीद',
  'chat.greeting.getWell': 'जल्दी ठीक हो जाइए',
  'chat.greeting.congratulations': 'बधाई',
  'chat.greeting.thankYou': 'धन्यवाद',
  'chat.greeting.today': 'आज: {name}',
  'chat.greeting.soon': 'जल्द ही: {name}',
  'chat.greeting.belated': 'देर से ही सही: {name}',
  'chat.greeting.anyDay': 'किसी भी दिन',
  'chat.greeting.designs': 'डिज़ाइन',
  'chat.greeting.design': '{name}, {total} में से डिज़ाइन {n}',
  'chat.greeting.scrollBack': 'पीछे देखें',
  'chat.greeting.scrollOn': 'आगे देखें',
  'chat.greeting.wishes': 'तैयार शुभकामनाएँ',
  'chat.greeting.day.dhanteras': 'धनतेरस',
  'chat.greeting.day.chhotiDiwali': 'छोटी दिवाली',
  'chat.greeting.day.lakshmiPuja': 'लक्ष्मी पूजा',
  'chat.greeting.day.govardhanPuja': 'गोवर्धन पूजा',
  'chat.greeting.day.bhaiDooj': 'भाई दूज',
  'chat.greeting.day.navratriAshtami': 'दुर्गा अष्टमी',
  'chat.greeting.day.navratriNavami': 'महानवमी',
  'chat.greeting.day.durgaShashthi': 'महाषष्ठी',
  'chat.greeting.day.durgaSaptami': 'महासप्तमी',
  'chat.greeting.day.durgaAshtami': 'महाअष्टमी',
  'chat.greeting.day.durgaNavami': 'महानवमी',
  'chat.greeting.day.vijayadashami': 'विजयादशमी',
  // ImageLightbox
  'chat.viewer.saved': 'डाउनलोड में सेव हो गई',
  'chat.viewer.couldNotDownload': 'फ़ोटो डाउनलोड नहीं हो पाई',
  'chat.viewer.download': 'डाउनलोड',
  'chat.viewer.downloading': 'फ़ोटो डाउनलोड हो रही है',
  'chat.viewer.toDocuments': 'डॉक्यूमेंट्स में',
  'chat.viewer.starred': 'स्टार किया',
  'chat.viewer.star': 'स्टार करें',
  'chat.viewer.goToChat': 'चैट पर जाएँ',
  // Message type labels (replyLabel)
  'chat.type.image': 'फ़ोटो',
  'chat.type.video': 'वीडियो',
  'chat.type.voice': 'वॉइस नोट',
  'chat.type.file': 'फ़ाइल',
  // MentionPicker
  'chat.mention.pick': 'किसी को मेंशन करें',
  // MessageActionSheet and messageActionItems
  'chat.actions.copied': 'कॉपी हो गया',
  'chat.actions.couldNotCopy': 'कॉपी नहीं हो पाया',
  'chat.actions.label': 'संदेश के विकल्प',
  'chat.actions.react': 'रिएक्ट करें',
  'chat.actions.reactWith': '{emoji} से रिएक्ट करें',
  'chat.actions.reply': 'जवाब दें',
  'chat.actions.copy': 'टेक्स्ट कॉपी करें',
  'chat.actions.edit': 'बदलें',
  'chat.actions.unstar': 'स्टार हटाएँ',
  'chat.actions.star': 'स्टार करें',
  'chat.actions.unpin': 'पिन हटाएँ',
  'chat.actions.pin': 'सबसे ऊपर पिन करें',
  'chat.actions.forward': 'फ़ॉरवर्ड करें…',
  'chat.actions.saveLink': 'परिवार के लिंक्स में सेव करें',
  'chat.actions.saveDocument': 'परिवार के डॉक्यूमेंट्स में सेव करें',
  'chat.actions.info': 'जानकारी',
  'chat.actions.seenCount': '{total} में से {n}',
  'chat.actions.delete': 'मिटाएँ…',
  'chat.actions.report': 'शिकायत करें…',
  // MessageBubble
  'chat.message.imageAlt': 'फ़ोटो',
  'chat.message.photoFailed': 'यह फ़ोटो नहीं खुल पाई',
  'chat.message.loadingVideo': 'वीडियो लोड हो रहा है',
  'chat.message.playVideo': 'वीडियो चलाएँ',
  'chat.message.videoFailed': 'यह वीडियो नहीं खुल पाया',
  'chat.message.voiceFailed': 'यह वॉइस नोट नहीं खुल पाया',
  'chat.message.locked': 'चाबी आने तक बंद है',
  'chat.message.unverified': 'इस संदेश की पुष्टि नहीं हो सकती',
  'chat.message.unbound': 'पुराना संदेश · भेजने वाले की पुष्टि नहीं',
  'chat.message.attachment': 'अटैचमेंट',
  'chat.message.seenBy': '{n} ने देखा',
  'chat.message.sent': 'भेजा गया',
  'chat.message.seen': 'देख लिया',
  'chat.message.forwarded': 'फ़ॉरवर्ड किया गया',
  'chat.message.replyDeleted': 'संदेश मिटा दिया गया',
  'chat.message.pinned': 'पिन किया',
  'chat.message.edited': 'बदला गया',
  'chat.message.includingYou': ', आप भी',
  // MessageComposer
  'chat.composer.cardFailed': 'कार्ड नहीं बन पाया',
  'chat.composer.micUnavailable': 'माइक्रोफ़ोन नहीं मिल रहा',
  'chat.composer.allowMic':
    'वॉइस नोट रिकॉर्ड करने के लिए माइक्रोफ़ोन की इजाज़त दें।',
  'chat.composer.editFailed': 'संदेश नहीं बदल पाया',
  'chat.composer.replyingTo': '{name} को जवाब',
  'chat.composer.replyingToMessage': 'संदेश का जवाब',
  'chat.composer.editing': 'संदेश बदल रहे हैं',
  'chat.composer.cancelReply': 'जवाब रद्द करें',
  'chat.composer.cancelEdit': 'बदलाव रद्द करें',
  'chat.composer.discardVoice': 'वॉइस नोट हटाएँ',
  'chat.composer.sendVoice': 'वॉइस नोट भेजें',
  'chat.composer.attach': 'फ़ोटो, वीडियो या फ़ाइल जोड़ें, या शुभकामना भेजें',
  'chat.composer.image': 'फ़ोटो या GIF',
  'chat.composer.saveEdit': 'बदलाव सेव करें',
  'chat.composer.send': 'संदेश भेजें',
  'chat.composer.record': 'वॉइस नोट रिकॉर्ड करें',
  // MessageList and messageUtils
  'chat.list.today': 'आज',
  'chat.list.yesterday': 'कल',
  'chat.list.start': 'बातचीत की शुरुआत',
  'chat.list.jumpLatest': 'सबसे नए संदेशों पर जाएँ',
  'chat.list.jumpLatestOne': 'सबसे नए संदेशों पर जाएँ, 1 नया',
  'chat.list.jumpLatestOther': 'सबसे नए संदेशों पर जाएँ, {n} नए',
  // NewDeviceBanner
  'chat.newDevice.title': 'यह डिवाइस इन संदेशों के लिए नया है',
  'chat.newDevice.body':
    'ये तब खुलेंगे जब Twinden आपके किसी पुराने डिवाइस पर खुला हो, या इस चैट में कोई और इसे खोले।',
  'chat.newDevice.step1':
    'अपने दूसरे फ़ोन या कंप्यूटर पर Twinden खोलें (या Safari का वह टैब जो आपने पहले इस्तेमाल किया था)।',
  'chat.newDevice.step2': 'यहाँ भी Twinden खुला रखें।',
  'chat.newDevice.step3': 'कुछ सेकंड रुकें: संदेश अपने-आप खुल जाएँगे।',
  'chat.newDevice.how': 'कैसे?',
  // Key store banners (D262): the browser can't keep this device's key
  'chat.keyStore.blocked.title':
    'आपका ब्राउज़र Twinden का साइट डेटा रोक रहा है',
  'chat.keyStore.blocked.body':
    'आपके संदेशों की चाबियों के लिए Twinden को जो साइट डेटा चाहिए, आपका ब्राउज़र उसे रोक रहा है। twinden.com के लिए साइट डेटा की अनुमति दें (Brave में: Shields → allow, या ‘Forget me when I close this site’ बंद करें), फिर पेज रीलोड करें।',
  'chat.keyStore.broken.title': 'इस ब्राउज़र का स्टोरेज काम नहीं कर रहा',
  'chat.keyStore.broken.body':
    'आपके संदेशों की चाबियों के लिए इस ब्राउज़र का स्टोरेज काम नहीं कर रहा। twinden.com का साइट डेटा साफ़ करें (DevTools → Application → Clear site data, या Brave settings → Site and Shields settings → twinden.com) और फिर से साइन इन करें।',
  'chat.keyStore.ephemeral.title':
    'यह ब्राउज़र आपके संदेशों की चाबियाँ भूल जाता है',
  'chat.keyStore.ephemeral.body':
    'आपके संदेशों की चाबियों के लिए Twinden को जो साइट डेटा चाहिए, आपका ब्राउज़र उसे भूल जाता है: टैब बंद करने पर चाबी भूल जाती है, इसलिए हर बार यह एक नया डिवाइस बन जाता है। twinden.com के लिए साइट डेटा की अनुमति दें (Brave में: ‘Forget me when I close this site’ बंद करें), फिर पेज रीलोड करें।',
  'chat.keyStore.slow.title': 'इस डिवाइस पर स्टोरेज धीमा है',
  'chat.keyStore.slow.body':
    'आपके संदेशों की चाबियाँ रखने वाला स्टोरेज Twinden समय पर नहीं खोल पाया। फिर से कोशिश करने के लिए पेज रीलोड करें।',
  'chat.keyStore.tooMany.title': 'आज बहुत सारे नए डिवाइस जुड़ गए',
  'chat.keyStore.tooMany.body':
    'इस खाते में आज बहुत सारे डिवाइस जोड़े गए हैं। कल फिर कोशिश करें।',
  'chat.keyStore.unsupported.title':
    'यह ब्राउज़र Twinden का एन्क्रिप्शन इस्तेमाल नहीं कर सकता',
  'chat.keyStore.unsupported.body':
    'यह ब्राउज़र Twinden का एन्क्रिप्शन इस्तेमाल नहीं कर सकता। कोई दूसरा ब्राउज़र आज़माएँ, या इसे अपडेट करें।',
  'chat.keyStore.unusable.title': 'इस डिवाइस की चाबी काम नहीं कर रही',
  'chat.keyStore.unusable.body':
    'इस डिवाइस की चाबी काम नहीं कर रही। नई चाबी पाने के लिए इस डिवाइस पर साइन आउट करके फिर से साइन इन करें।',
  'chat.keyStore.replaced.title': 'इस डिवाइस की चाबी काम नहीं आ सकी',
  'chat.keyStore.replaced.body':
    'Twinden ने नई चाबी बना ली है। आपके संदेश तब खुलेंगे जब Twinden आपके किसी पुराने डिवाइस पर खुला हो, या चैट में कोई और इसे खोले।',
  'chat.keyStore.step1':
    'Brave: एड्रेस बार में Shields आइकन पर क्लिक करें, twinden.com के लिए साइट डेटा की अनुमति दें (या यहाँ Shields बंद करें) और ‘Forget me when I close this site’ बंद करें।',
  'chat.keyStore.step2':
    'Safari: Private टैब बंद होते ही सब कुछ भूल जाता है। twinden.com को सामान्य टैब में खोलें।',
  'chat.keyStore.step3':
    'कोई भी ब्राउज़र: ‘Block all cookies’ साइट डेटा भी रोक देता है। twinden.com के लिए कुकीज़ की अनुमति दें, फिर यह पेज रीलोड करें।',
  // InstallNudge (D184)
  'chat.install.label': 'Twinden इंस्टॉल करें',
  'chat.install.body':
    'सूचनाओं और पूरी स्क्रीन वाले ऐप के लिए Twinden इंस्टॉल करें',
  'chat.install.install': 'इंस्टॉल करें',
  'chat.install.how': 'कैसे',
  'chat.install.notNow': 'अभी नहीं',
  // The store app instead of the web app, on a phone (D346)
  'chat.install.getApp': 'Twinden ऐप पाएँ',
  'chat.install.getAppBody':
    'सूचनाएँ और कॉल फ़ोन वाले ऐप में सबसे अच्छी चलती हैं।',
  'chat.install.openStore': 'ऐप पाएँ',
  // PinnedBanner
  'chat.pinned.nOfTotal': 'पिन किया संदेश {n}/{total}',
  'chat.pinned.one': 'पिन किया संदेश',
  // Drafts in the chat list (M62, D228)
  'chat.draft.label': 'ड्राफ़्ट:',
  // Unread divider (M62, D229)
  'chat.unread.one': '1 अनपढ़ा संदेश',
  'chat.unread.other': '{n} अनपढ़े संदेश',
  // MessageInfoSheet (M62, D227)
  'chat.info.title': 'संदेश की जानकारी',
  'chat.info.sent': 'भेजा: {when}',
  'chat.info.edited': 'बदला: {when}',
  'chat.info.when': '{date} को {time}',
  'chat.info.seenBy': 'किसने देखा',
  'chat.info.notYet': 'अभी नहीं',
  'chat.info.seen': 'देख लिया',
  'chat.info.nobody': 'अभी तक किसी ने नहीं देखा।',
  // SecurityCodeDialog
  'chat.security.noDevices': 'अभी कोई डिवाइस नहीं',
  'chat.security.them': 'उन',
  'chat.security.body':
    'यहाँ के संदेश एंड-टू-एंड एन्क्रिप्टेड हैं। इन्हें {name} के साथ आमने-सामने या कॉल पर मिलाएँ: अगर आप दोनों को यही दो कोड दिखें, तो इन्हें सिर्फ़ आपके डिवाइस पढ़ सकते हैं।',
  'chat.security.yours': 'आपका कोड',
  'chat.security.theirs': '{name} का कोड',
  'chat.security.changes':
    'जब कोई फ़ोन या कंप्यूटर जोड़ता या हटाता है, तो कोड बदल जाता है।',
  'chat.codesNeedUpdate':
    'कोड तभी मिलेंगे जब आप दोनों के पास Twinden का नया ऐप हो।',
  'chat.security.deviceNeedsUpdate': '{name} के एक डिवाइस को अपडेट चाहिए।',
  'chat.security.thisDeviceSafe': 'यह डिवाइस: क्वांटम-सुरक्षित कुंजी ✓',
  'chat.security.thisDeviceNotSafe':
    'इस डिवाइस के पास अभी क्वांटम-सुरक्षित कुंजी नहीं है।',
  // MessageList: someone gained a device (M73, D303), this device only
  'chat.devicesChanged': '{name} के डिवाइस बदले · सुरक्षा कोड देखें',
  // Someone joined after this device first looked at who was in (D343)
  'chat.memberAdded': '{name} को इस चैट में जोड़ा गया',
  'chat.memberJoinedFamily': '{name} परिवार से जुड़े',
  // OwnDeviceNotice: a new device on my account, from this device's record (M73)
  'chat.ownDeviceAdded': 'आपके खाते में नया डिवाइस जुड़ा · अपने डिवाइस देखें',
  // VoiceNotePlayer
  'chat.voice.pause': 'वॉइस नोट रोकें',
  'chat.voice.play': 'वॉइस नोट चलाएँ',
  'chat.voice.position': 'वॉइस नोट कहाँ तक चला',
  // PendingBand
  'chat.pending.notSentError': 'नहीं गया · {error}',
  'chat.pending.notSentTap': 'नहीं गया · फिर भेजने के लिए टैप करें',
  'chat.pending.sendingVideos': 'वीडियो भेज रहे हैं',
  'chat.pending.sendingPhotos': 'फ़ोटो भेज रहे हैं',
  'chat.pending.videosDone': '{total} में से {n} वीडियो',
  'chat.pending.photosDone': '{total} में से {n} फ़ोटो',
  'chat.pending.sending': 'भेज रहे हैं',
  'chat.pending.uploading': 'अपलोड हो रहा है, {percent}%',
  'chat.pending.sendingFile': '{name} भेज रहे हैं',
  'chat.pending.sendingDots': 'भेज रहे हैं…',
  'chat.pending.cancel': 'भेजना रोकें',
  'chat.pending.notSent': 'नहीं गया',
  'chat.pending.retrying': 'कनेक्शन टूट गया, फिर कोशिश कर रहे हैं…',
  // CallOverlay and CallTile
  'chat.callScreen.muted': 'म्यूट',
  'chat.callScreen.end': 'कॉल काटें',
  'chat.callScreen.call': 'कॉल',
  'chat.callScreen.participant': 'सदस्य',
  'chat.callScreen.calling': 'कॉल हो रही है',
  'chat.callScreen.isCallingGroup': '{name} को कॉल कर रहे हैं',
  'chat.callScreen.isCallingYou': 'आपको कॉल कर रहे हैं',
  'chat.callScreen.connecting': 'जुड़ रहे हैं…',
  'chat.people.title': 'इस चैट में · {n}',
  'chat.people.seeWho': 'देखें इस चैट में कौन है',
  'chat.people.seePhoto': '{name} की तस्वीर देखें',
  'chat.people.photoOf': '{name} की तस्वीर',
  'chat.bless.default': 'जीते रहो 🙏',
  'chat.bless.action': 'आशीर्वाद दें',
  'chat.bless.quick': '{name} के संदेश पर आशीर्वाद दें',
  'chat.callScreen.callingDots': 'कॉल कर रहे हैं…',
  'chat.callScreen.ringingDots': 'घंटी बज रही है…',
  'chat.callScreen.voiceTitle': 'Twinden वॉइस कॉल',
  'chat.callScreen.videoTitle': 'Twinden वीडियो कॉल',
  'chat.callScreen.declineCall': 'कॉल मना करें',
  'chat.callScreen.cancelCall': 'कॉल रद्द करें',
  'chat.callScreen.decline': 'मना करें',
  'chat.callScreen.answerCall': 'कॉल उठाएँ',
  'chat.callScreen.answer': 'उठाएँ',
  'chat.callScreen.addSomeone': 'कॉल में किसी को जोड़ें',
  'chat.callScreen.addTitle': 'कॉल में जोड़ें',
  'chat.callScreen.ringing': '{name} को घंटी जा रही है…',
  'chat.callScreen.ring': 'घंटी करें',
  'chat.callScreen.minimise': 'कॉल छोटी करें',
  'chat.callScreen.pictureInPicture': 'पिक्चर-इन-पिक्चर',
  'chat.callScreen.inPictureInPicture': 'पिक्चर-इन-पिक्चर में दिख रही है',
  'chat.callScreen.cameraOff': 'कैमरा बंद',
  'chat.callScreen.reconnecting': 'फिर से जुड़ रहे हैं…',
  'chat.callScreen.yourCameraOff': 'आपका कैमरा बंद है',
  'chat.callScreen.muteMic': 'माइक बंद करें',
  'chat.callScreen.unmuteMic': 'माइक चालू करें',
  'chat.callScreen.cameraOffAction': 'कैमरा बंद करें',
  'chat.callScreen.cameraOnAction': 'कैमरा चालू करें',
  'chat.callScreen.flip': 'कैमरा पलटें',
  'chat.callScreen.weakVideoPaused': 'कमज़ोर कनेक्शन — वीडियो रोका गया',
  'chat.callScreen.videoBetter': 'कनेक्शन बेहतर है — वीडियो चालू करें?',
  'chat.callScreen.turnVideoOn': 'वीडियो चालू करें',
  'chat.callScreen.voiceClock': 'वॉइस · {clock}',
  'chat.callScreen.speaking': 'बोल रहे हैं',
  'chat.callScreen.mute': 'म्यूट',
  'chat.callScreen.unmute': 'अनम्यूट',
  'chat.callScreen.backTo': '{name} के साथ कॉल पर वापस जाएँ',
  'chat.callScreen.yourFamily': 'परिवार',
  'chat.callScreen.onCallWith': '{name} के साथ कॉल पर',
  // useCall
  'chat.callErrors.denied': 'कैमरा और माइक्रोफ़ोन की इजाज़त नहीं मिली',
  'chat.callErrors.notFound': 'कोई कैमरा या माइक्रोफ़ोन नहीं मिला',
  'chat.callErrors.inUse':
    'आपका कैमरा या माइक्रोफ़ोन कोई दूसरा ऐप इस्तेमाल कर रहा है',
  'chat.callErrors.couldNotStart': 'कॉल शुरू नहीं हो पाई',
  'chat.callErrors.busy': 'वे किसी और कॉल पर हैं',
  'chat.callErrors.ended': 'कॉल खत्म हुई',
  'chat.callErrors.unavailable': 'कॉल अभी उपलब्ध नहीं हैं',
  'chat.callErrors.couldNotSwitch': 'कैमरा नहीं बदल पाया',
  // attachments and outbox
  'chat.send.uploadFailed': 'अपलोड नहीं हो पाया',
  'chat.send.couldNotSend': 'भेज नहीं पाए',
  // ChatPage
  'chat.page.deleteFailed': 'संदेश नहीं मिट पाया',
  'chat.page.unknownError': 'पता नहीं क्या गड़बड़ हुई',
  'chat.page.everyoneInChat': 'इस चैट में सब लोग',
  'chat.page.someone': 'कोई',
  'chat.page.tooFarBack': 'वह संदेश बहुत पुराना है, खुल नहीं सकता',
  'chat.page.reactFailed': 'रिएक्ट नहीं हो पाया',
  'chat.page.notificationsFailed': 'सूचनाएँ नहीं बदल पाईं',
  'chat.page.unstarFailed': 'स्टार नहीं हटा पाए',
  'chat.page.starFailed': 'स्टार नहीं कर पाए',
  'chat.page.alreadyInLinks': 'परिवार के लिंक्स में पहले से है',
  'chat.page.savedToLinks': 'परिवार के लिंक्स में सेव हो गया',
  'chat.page.view': 'देखें',
  'chat.page.saveLinkFailed': 'लिंक सेव नहीं हो पाया',
  'chat.page.savedToDocuments': 'परिवार के डॉक्यूमेंट्स में सेव हो गया',
  'chat.page.saveDocumentFailed': 'डॉक्यूमेंट सेव नहीं हो पाया',
  'chat.page.unpinFailed': 'पिन नहीं हटा पाए',
  'chat.page.pinFailed': 'पिन नहीं कर पाए',
  'chat.page.forwarded': 'फ़ॉरवर्ड हो गया',
  'chat.page.forwardedTo': '{n} चैट में फ़ॉरवर्ड हो गया',
  'chat.page.forwardFailed': 'फ़ॉरवर्ड नहीं हो पाया',
  'chat.page.editRefused': 'आपका बदलाव सेव नहीं हो पाया',
  'chat.page.reactionRefused': 'आपका रिएक्शन सेव नहीं हो पाया',
  'chat.page.notInvited': 'आपको अभी तक बुलाया नहीं गया है',
  'chat.page.askRoot': 'अपने परिवार के रूट से QR कोड या न्योता माँगें।',
  'chat.page.sayToEveryone': 'सबसे कुछ कहें',
  'chat.page.messageTo': '{name} को संदेश भेजें',
  'chat.page.messageGroup': 'ग्रुप में संदेश भेजें',
  'chat.page.messageThem': 'संदेश भेजें',
  'chat.page.select': 'बात शुरू करने के लिए कोई चैट चुनें',
  'chat.page.messageInGroup': '{name} में संदेश भेजें',
  // MentionsPage
  'chat.mentions.title': 'मेंशन',
  'chat.mentions.subtitle':
    'जब कोई आपको @मेंशन करे, या आपके किसी ग्रुप में @everyone लिखे',
  'chat.mentions.loading': 'आपके मेंशन लोड हो रहे हैं…',
  'chat.mentions.empty': 'अभी कोई मेंशन नहीं',
  'chat.mentions.emptyBody':
    'जब कोई @{handle} या @everyone लिखेगा, तो वह यहाँ दिखेगा।',
  'chat.mentions.itemNew': 'नया: {chat} में {name}',
  'chat.mentions.item': '{chat} में {name}',
  'chat.mentions.older': 'पुराने मेंशन दिखाएँ',
  // CallsPage
  'chat.calls.video': 'वीडियो',
  'chat.calls.voice': 'वॉइस',
  'chat.calls.missedVideoOther': 'छूटी हुई वीडियो कॉल',
  'chat.calls.missedVoiceOther': 'छूटी हुई वॉइस कॉल',
  'chat.calls.declinedLabel': 'मना की',
  'chat.calls.declined': 'मना की · {kind}',
  'chat.calls.youDeclined': 'आपने मना की · {kind}',
  'chat.calls.outgoing': 'की गई',
  'chat.calls.incoming': 'आई हुई',
  'chat.calls.cancelled': 'रद्द · {kind}',
  'chat.calls.noAnswer': 'नहीं उठी · {kind}',
  'chat.calls.chat': 'चैट',
  'chat.calls.newCall': 'नई कॉल',
  'chat.calls.voiceCallName': '{name} को वॉइस कॉल',
  'chat.calls.videoCallName': '{name} को वीडियो कॉल',
  'chat.calls.callName': '{name} को कॉल करें',
  'chat.calls.callBackName': '{name} को वापस कॉल करें',
  'chat.calls.videoCallBack': '{name} को वापस वीडियो कॉल करें',
  'chat.calls.title': 'कॉल',
  'chat.calls.all': 'सभी',
  'chat.calls.missedCount': 'छूटी हुई · {n}',
  'chat.calls.loading': 'आपकी कॉल लोड हो रही हैं…',
  'chat.calls.noMissed': 'कोई छूटी हुई कॉल नहीं',
  'chat.calls.none': 'अभी कोई कॉल नहीं',
  'chat.calls.caughtUp': 'सब देख लिया।',
  'chat.calls.emptyBody':
    '{family} के साथ कॉल यहाँ दिखेंगी। किसी भी चैट से, या नई कॉल से शुरू करें।',
  'chat.calls.earlier': 'पहले',
  'chat.calls.older': 'पुरानी कॉल दिखाएँ',
  // Deleted accounts (M51).
  'chat.system.rootHandover':
    'परिवार के रूट ने अपना अकाउंट मिटा दिया। अब {name} रूट हैं।',
  // SharePage (Share to Twinden, D177–D182)
  'chat.share.title': 'किसे भेजें…',
  'chat.share.subtitleFiles': '{n} शेयर किए गए · चैट चुनें',
  'chat.share.subtitleText': 'किस चैट में लिखना है, चुनें',
  'chat.share.loading': 'शेयर की गई चीज़ें खुल रही हैं…',
  'chat.share.cancel': 'शेयर करना रद्द करें',
  'chat.share.chooseChat': 'चैट',
  'chat.share.messagePlaceholder': 'संदेश जोड़ें',
  'chat.share.messageLabel': 'संदेश',
  'chat.share.pickFirst': 'चैट चुनें',
  'chat.share.sendTo': '{name} को भेजें',
  'chat.share.writeIn': '{name} में लिखें',
  'chat.share.preparing': '{total} में से {done} भेजा जा रहा है…',
  'chat.share.cantSendType': 'Twinden इस तरह की फ़ाइल नहीं भेज सकता',
  'chat.share.tooBig': 'भेजने के लिए बहुत बड़ी (ज़्यादा से ज़्यादा 50 MB)',
  'chat.share.goneTitle': 'शेयर करने को कुछ नहीं',
  'chat.share.goneBody':
    'यह शेयर भेजा जा चुका है, रद्द हो चुका है या एक दिन से पुराना है। दूसरे ऐप से फिर से शेयर करें।',
  'chat.share.failedBody':
    'Twinden शेयर की गई चीज़ें इस फ़ोन पर नहीं रख सका। दूसरे ऐप से फिर से शेयर करें।',
  'chat.share.toChats': 'चैट पर जाएँ',
  'chat.share.skipped': '{names} नहीं भेजा जा सका',
  'chat.share.tooBigBody':
    'यह एक शेयर में Twinden जितना रखता है (200 MB), उससे ज़्यादा था। एक बार में कम फ़ाइलें शेयर करें।',

  // Thank-you card at the top of the chats (M55, D197)
  'chat.thanks.label': 'Twinden की ओर से धन्यवाद',
  'chat.thanks.coveredMany':
    '{month}: {count} परिवारों ने {received} का योगदान दिया और Twinden का {total} का ख़र्च पूरा किया। धन्यवाद।',
  'chat.thanks.coveredOne':
    '{month}: {count} परिवार ने {received} का योगदान दिया और Twinden का {total} का ख़र्च पूरा किया। धन्यवाद।',
  'chat.thanks.covered':
    '{month}: परिवारों ने {received} का योगदान दिया और Twinden का {total} का ख़र्च पूरा किया। धन्यवाद।',
  'chat.thanks.shortMany':
    '{month}: {count} परिवारों ने Twinden के {total} के ख़र्च में से {received} दिए। धन्यवाद।',
  'chat.thanks.shortOne':
    '{month}: {count} परिवार ने Twinden के {total} के ख़र्च में से {received} दिए। धन्यवाद।',
  'chat.thanks.short':
    '{month}: परिवारों ने Twinden के {total} के ख़र्च में से {received} दिए। धन्यवाद।',
  'chat.thanks.noFigures':
    '{month}: Twinden का ख़र्च {total} है, जिसे इसे इस्तेमाल करने वाले परिवार उठाते हैं।',
  'chat.thanks.chipIn': 'योगदान दें',
  'chat.thanks.ok': 'ठीक है',
  'chat.thanks.safari': 'योगदान देने के लिए twinden.com को Safari में खोलें',
  // M60 (docs/chat-round-three.md)
  'chat.type.album': 'फ़ोटो',
  'chat.type.poll': 'पोल',
  'chat.type.unknown': 'संदेश',
  'chat.message.updateApp': 'यह संदेश देखने के लिए Twinden अपडेट करें',
  'chat.home.sentPhotos': '{n} फ़ोटो भेजीं',
  'chat.home.sentVideos': '{n} वीडियो भेजे',
  'chat.home.sentMixed': '{n} फ़ोटो और वीडियो भेजे',
  'chat.home.whoSentPhotos': '{name} ने {n} फ़ोटो भेजीं',
  'chat.home.whoSentVideos': '{name} ने {n} वीडियो भेजे',
  'chat.home.whoSentMixed': '{name} ने {n} फ़ोटो और वीडियो भेजे',
  'chat.album.count': '{n} भेजने हैं',
  'chat.album.remove': '{name} हटाएँ',
  'chat.album.clear': 'इन्हें न भेजें',
  'chat.album.captionPlaceholder': 'कैप्शन जोड़ें',
  'chat.album.send': 'एल्बम भेजें',
  'chat.album.open': '{total} में से {n} खोलें',
  'chat.album.label': '{n} का एल्बम',
  'chat.viewer.position': '{total} में से {n}',
  'chat.viewer.previous': 'पिछला',
  'chat.viewer.next': 'अगला',
  'chat.composer.photosVideos': 'फ़ोटो और वीडियो',
  'chat.composer.poll': 'पोल',
  'chat.composer.gathering': 'बुलावा',
  'chat.poll.quote': 'पोल: {question}',
  'chat.poll.title': 'नया पोल',
  'chat.poll.question': 'सवाल',
  'chat.poll.questionPlaceholder': 'कुछ पूछें',
  'chat.poll.options': 'विकल्प',
  'chat.poll.option': 'विकल्प {n}',
  'chat.poll.addOption': 'विकल्प जोड़ें',
  'chat.poll.removeOption': 'विकल्प {n} हटाएँ',
  'chat.poll.multiple': 'एक से ज़्यादा जवाब चुनने दें',
  'chat.poll.closeAfter': 'कब बंद हो',
  'chat.poll.never': 'कभी नहीं',
  'chat.poll.hour': '1 घंटा',
  'chat.poll.day': '1 दिन',
  'chat.poll.week': '1 हफ़्ता',
  'chat.poll.visibleVotes': 'चैट में सभी देख सकते हैं कि किसने क्या चुना।',
  'chat.poll.create': 'पोल भेजें',
  'chat.poll.invalid': 'एक सवाल और कम से कम दो विकल्प जोड़ें',
  'chat.poll.chooseOne': 'एक चुनें',
  'chat.poll.chooseAny': 'जितने चाहें चुनें',
  'chat.poll.vote': 'वोट दें',
  'chat.poll.votesOne': '1 वोट',
  'chat.poll.votesOther': '{n} वोट',
  'chat.poll.changeVote': 'वोट बदलें',
  'chat.poll.retract': 'मेरा वोट वापस लें',
  'chat.poll.close': 'पोल बंद करें',
  'chat.poll.closed': 'पोल बंद हो गया',
  'chat.poll.closesAt': '{time} बंद होगा',
  'chat.poll.voteFailed': 'आपका वोट सहेजा नहीं जा सका',
  'chat.poll.closeFailed': 'पोल बंद नहीं हो सका',
  'chat.poll.needsKeys':
    'पोल एंड-टू-एंड एन्क्रिप्टेड होते हैं: यह डिवाइस अपनी चाबियाँ ले रहा है, थोड़ा रुकें।',
  'chat.poll.votedBy': 'वोट दिया: {names}',
  'chat.poll.locked': 'इस पोल की चाबी का इंतज़ार…',
  // M71 (docs/gatherings.md, D282)
  'chat.type.gathering': 'बुलावा',
  'chat.gathering.today': 'आज, {time}',
  'chat.gathering.tomorrow': 'कल, {time}',
  'chat.gathering.needsKeys':
    'बुलावे एंड-टू-एंड एन्क्रिप्टेड होते हैं: यह डिवाइस अपनी चाबियाँ ले रहा है, थोड़ा रुकें।',
  'chat.gathering.title': 'खाने का बुलावा',
  'chat.gathering.titleLabel': 'क्या है?',
  'chat.gathering.titlePlaceholder': 'रात का खाना',
  'chat.gathering.quickBreakfast': 'नाश्ता',
  'chat.gathering.quickLunch': 'दोपहर का खाना',
  'chat.gathering.quickDinner': 'रात का खाना',
  'chat.gathering.quickChai': 'चाय',
  'chat.gathering.quickMovie': 'फ़िल्म',
  'chat.gathering.quickOuting': 'घूमना',
  'chat.gathering.quickMeetUp': 'मिलना',
  'chat.gathering.day': 'दिन',
  'chat.gathering.dayToday': 'आज',
  'chat.gathering.dayTomorrow': 'कल',
  'chat.gathering.dayPick': 'तारीख़ चुनें',
  'chat.gathering.time': 'समय',
  'chat.gathering.place': 'कहाँ (ज़रूरी नहीं)',
  'chat.gathering.placePlaceholder': 'नानी की छत',
  'chat.gathering.note': 'एक बात (ज़रूरी नहीं)',
  'chat.gathering.notePlaceholder': 'ताश लेते आना',
  'chat.gathering.rings': 'समय होने पर लोगों को घंटी दें',
  'chat.gathering.ringsHint':
    'जिन्होंने “आज नहीं” नहीं कहा, उन्हें आपके “अभी आओ” दबाने पर घंटी जाएगी।',
  'chat.gathering.visible': 'चैट में सब देखते हैं कि कौन आ रहा है',
  'chat.gathering.create': 'भेजें',
  'chat.gathering.timeError': 'अभी से 60 दिन के भीतर का समय चुनें।',
  'chat.gathering.coming': 'आ रहा हूँ',
  'chat.gathering.late': 'देर से',
  'chat.gathering.not': 'आज नहीं',
  'chat.gathering.here': 'मैं पहुँच गया',
  'chat.gathering.lateBy': '+{n} मिनट',
  'chat.gathering.takeBack': 'मेरा जवाब वापस लें',
  'chat.gathering.lateMenu': 'कितनी देर?',
  'chat.gathering.comeNow': 'अभी आओ',
  'chat.gathering.ringDinner': 'खाना तैयार है — अभी आओ',
  'chat.gathering.ringTitle': '{title} — अभी आओ',
  'chat.gathering.ringGeneric': 'अभी आओ',
  'chat.gathering.ringComing': 'मैं आ रहा हूँ',
  'chat.gathering.ringSnooze': '5 मिनट और',
  'chat.gathering.cancel': 'रद्द करें',
  'chat.gathering.cancelConfirm': 'यह बुलावा रद्द करें?',
  'chat.gathering.cancelKeep': 'रहने दें',
  'chat.gathering.cancelYes': 'रद्द करें',
  'chat.gathering.ended': 'ख़त्म',
  'chat.gathering.cancelled': 'रद्द',
  'chat.gathering.countComing': '{n} आ रहे',
  'chat.gathering.countLate': '{n} देर से',
  'chat.gathering.countNot': '{n} आज नहीं',
  'chat.gathering.countUnanswered': '{n} ने नहीं बताया',
  'chat.gathering.noneYet': 'अभी किसी ने जवाब नहीं दिया',
  'chat.gathering.groupComing': 'आ रहे',
  'chat.gathering.groupLate': 'देर से',
  'chat.gathering.groupNot': 'आज नहीं',
  'chat.gathering.lateName': '{name} (+{n} मिनट)',
  'chat.gathering.atTable': '{total} में से {n} मेज़ पर',
  'chat.gathering.ringsLimit': 'दो बार घंटी जा चुकी',
  'chat.gathering.ringsTooSoon': 'दो घंटियों के बीच 3 मिनट रुकें',
  'chat.gathering.ringsOff': 'इसमें घंटी बंद है',
  'chat.gathering.invalid':
    'बुलावे का शीर्षक या बात बहुत लंबी है, या शीर्षक ख़ाली है।',
  'chat.gathering.replyFailed': 'आपका जवाब सहेजा नहीं जा सका',
  'chat.gathering.arriveFailed': 'यह बताया नहीं जा सका कि आप पहुँच गए',
  'chat.gathering.ringFailed': 'घंटी नहीं जा सकी',
  'chat.gathering.cancelFailed': 'रद्द नहीं हो सका',
  'chat.gathering.errEnded': 'यह बुलावा ख़त्म हो चुका है।',
  'chat.gathering.errLimit': 'दो बार घंटी जा चुकी।',
  'chat.gathering.errTooSoon': 'दो घंटियों के बीच 3 मिनट रुकें।',
  'chat.gathering.errRingsOff': 'इस बुलावे में घंटी बंद है।',
  'chat.gathering.errCancelNotAllowed': 'सिर्फ़ बनाने वाला रद्द कर सकता है।',
  'chat.gathering.errRingNotAllowed':
    'सिर्फ़ बनाने वाला या परिवार का एडमिन घंटी दे सकता है।',
  'chat.gathering.errInPast': 'वह समय बीत चुका है।',
  'chat.gathering.errTooFar': 'बहुत आगे का समय है: 60 दिन के भीतर चुनें।',
  'chat.voice.speed': 'चलने की रफ़्तार {speed}',
  // M63 chat round five (D231–D235)
  'chat.chatActions.label': 'चैट के विकल्प',
  'chat.chatActions.more': '{name} के और विकल्प',
  'chat.chatActions.markRead': 'पढ़ा हुआ मानें',
  'chat.chatActions.markUnread': 'बिना पढ़ा मानें',
  'chat.chatActions.mute': 'म्यूट करें…',
  'chat.chatActions.unmute': 'म्यूट हटाएँ',
  'chat.chatActions.mutedUntil': '{time} तक म्यूट',
  'chat.chatActions.mutedAlways': 'म्यूट है',
  'chat.chatActions.archive': 'आर्काइव करें',
  'chat.chatActions.unarchive': 'आर्काइव से निकालें',
  'chat.chatActions.keepArchived': 'आर्काइव में ही रखें',
  'chat.chatActions.keepArchivedHint':
    'नए मैसेज आने पर भी न वापस आएगी, न सूचना देगी',
  'chat.chatActions.failed': 'यह चैट नहीं बदल पाए',
  'chat.chatActions.archived': 'आर्काइव कर दी',
  'chat.chatActions.unarchived': 'आपकी चैट में वापस',
  'chat.archived.row': 'आर्काइव',
  'chat.archived.rowCount': 'आर्काइव · {n}',
  'chat.archived.title': 'आर्काइव',
  'chat.archived.back': 'चैट पर वापस',
  'chat.archived.empty': 'आर्काइव में कुछ नहीं',
  'chat.archived.hint':
    'आर्काइव की गई चैट नया मैसेज आने पर वापस आ जाती है, जब तक आप उसे आर्काइव में ही रखना न चुनें।',
  'chat.archived.unreadSuffix': ', कुछ नया है',
  'chat.mute.title': '{name} को म्यूट करें',
  'chat.mute.body':
    'न सूचनाएँ, न आवाज़। चैट आपकी सूची में रहेगी, और @मेंशन फिर भी आप तक पहुँचेंगे।',
  'chat.mute.eightHours': '8 घंटे',
  'chat.mute.oneWeek': '1 हफ़्ता',
  'chat.mute.always': 'हमेशा',
  'chat.mute.done': 'म्यूट कर दी',
  'chat.mute.undone': 'सूचनाएँ फिर चालू',
  'chat.header.muteEllipsis': 'म्यूट करें…',
  'chat.header.mutedUntil': '{time} तक म्यूट',
  'chat.info.picture': 'ग्रुप की फ़ोटो',
  'chat.info.changePicture': 'फ़ोटो बदलें',
  'chat.info.removePicture': 'हटाएँ',
  'chat.info.pictureUpdated': 'ग्रुप की फ़ोटो बदल दी',
  'chat.info.pictureRemoved': 'ग्रुप की फ़ोटो हटा दी',
  'chat.info.pictureFailed': 'फ़ोटो नहीं बदल पाए',
  'chat.info.description': 'विवरण',
  'chat.info.descriptionPlaceholder': 'यह ग्रुप किसलिए है',
  'chat.info.descriptionCount': '{max} में से {n}',
  'chat.info.noDescription': 'अभी कोई विवरण नहीं',
  'chat.info.descriptionLocked': 'विवरण दिखाने के लिए चाबी का इंतज़ार…',
  'chat.info.encryptedNote':
    'विवरण एंड-टू-एंड एन्क्रिप्टेड है। ग्रुप में हर कोई नाम, फ़ोटो और विवरण बदल सकता है।',
  'chat.info.adminsOnlyNote':
    'परिवार का ग्रुप सिर्फ़ परिवार के रूट और एडमिन बदलते हैं।',
  'chat.info.saved': 'ग्रुप की जानकारी सहेज ली',
  'chat.info.saveFailed': 'ग्रुप की जानकारी नहीं सहेज पाए',
  'chat.info.keysNotReady':
    'यह डिवाइस अभी अपनी चाबियाँ ले रहा है। थोड़ी देर में फिर कोशिश करें।',
  'chat.system.groupRenamed': '{name} ने ग्रुप का नाम बदलकर “{group}” किया',
  'chat.system.groupPicture': '{name} ने ग्रुप की फ़ोटो बदली',
  'chat.system.groupPictureRemoved': '{name} ने ग्रुप की फ़ोटो हटाई',
  'chat.system.groupDescription': '{name} ने ग्रुप का विवरण बदला',
  'chat.actions.replyPrivately': 'अलग से जवाब दें',
  'chat.replyPrivately.blocked': 'आप इन्हें मैसेज नहीं कर सकते',
  'chat.replyPrivately.failed': 'चैट नहीं खुल पाई',
  // M64 (docs/chat-round-six.md): pins, disappearing, send later.
  'chat.chatActions.pin': 'ऊपर पिन करें',
  'chat.chatActions.unpin': 'पिन हटाएँ',
  'chat.chatActions.pinLimit': 'आप ज़्यादा से ज़्यादा {n} चैट पिन कर सकते हैं',
  'chat.home.pinnedSuffix': ', पिन की हुई',
  'chat.disappearing.title': 'गायब होने वाले मैसेज',
  'chat.disappearing.body':
    'इस चैट के नए मैसेज आपके चुने समय के बाद सबके लिए गायब हो जाएँगे। पहले भेजे मैसेज वैसे ही रहेंगे।',
  'chat.disappearing.off': 'बंद',
  'chat.disappearing.24h': '24 घंटे',
  'chat.disappearing.7d': '7 दिन',
  'chat.disappearing.90d': '90 दिन',
  'chat.disappearing.current': 'अभी यही',
  'chat.disappearing.headerOn': 'गायब होने वाले मैसेज: {time}',
  'chat.disappearing.failed': 'गायब होने वाले मैसेज नहीं बदल सके',
  'chat.disappearing.turnedOn': 'नए मैसेज {time} बाद गायब हो जाएँगे',
  'chat.disappearing.turnedOff': 'गायब होने वाले मैसेज बंद हैं',
  'chat.system.disappearingOn':
    '{name} ने गायब होने वाले मैसेज चालू किए ({time})',
  'chat.system.disappearingOff': '{name} ने गायब होने वाले मैसेज बंद किए',
  'chat.message.disappears': '{time} को गायब होगा',
  'chat.composer.sendLater': 'बाद में भेजें…',
  'chat.sendLater.title': 'बाद में भेजें',
  'chat.sendLater.body':
    'चुनें कि कब जाए। यह अभी इसी डिवाइस पर सील होगा और उसी समय भेजा जाएगा।',
  'chat.sendLater.inAnHour': '1 घंटे में',
  'chat.sendLater.tonight': 'आज रात, {time}',
  'chat.sendLater.tomorrow': 'कल, {time}',
  'chat.sendLater.pick': 'या तारीख़ और समय चुनें',
  'chat.sendLater.schedule': 'शेड्यूल करें',
  'chat.sendLater.tooSoon': 'अभी से कम से कम 5 मिनट बाद का समय चुनें',
  'chat.sendLater.tooFar': 'अगले 30 दिनों में का समय चुनें',
  'chat.sendLater.needText': 'पहले मैसेज लिखें',
  'chat.sendLater.textOnly': 'बाद में सिर्फ़ टेक्स्ट मैसेज भेजे जा सकते हैं',
  'chat.sendLater.needsKeys':
    'यह डिवाइस अभी अपनी चाबियाँ ले रहा है। थोड़ी देर में फिर कोशिश करें।',
  'chat.sendLater.done': '{time} के लिए शेड्यूल किया',
  'chat.sendLater.failed': 'वह मैसेज शेड्यूल नहीं हो सका',
  'chat.scheduled.list': 'शेड्यूल किए मैसेज',
  'chat.scheduled.label': 'शेड्यूल · {time}',
  'chat.scheduled.sendNow': 'अभी भेजें',
  'chat.scheduled.cancel': 'शेड्यूल किया मैसेज रद्द करें',
  'chat.scheduled.cancelled': 'शेड्यूल किया मैसेज रद्द हुआ',
  'chat.scheduled.needsPhone': 'भेजने के लिए आपका फ़ोन चाहिए',
  'chat.scheduled.locked': 'एन्क्रिप्टेड मैसेज',
  'chat.scheduled.failed': 'वह शेड्यूल किया मैसेज नहीं बदल सका',
  'chat.scheduled.sent': 'भेज दिया',
  'chat.scheduled.resealing': 'नई चाबी के लिए फिर से सील हो रहा है…',
  'chat.sendLater.invalid': 'तारीख़ और समय चुनें',
  // EmojiPicker (M69, D263–D265)
  'chat.emoji.open': 'इमोजी',
  'chat.emoji.keyboard': 'वापस कीबोर्ड पर',
  'chat.emoji.picker': 'इमोजी चुनें',
  'chat.emoji.search': 'इमोजी खोजें',
  'chat.emoji.noResults': '“{query}” के लिए कोई इमोजी नहीं',
  'chat.emoji.loading': 'इमोजी आ रहे हैं…',
  'chat.emoji.failed': 'इमोजी नहीं आ सके। ऑनलाइन होने पर फिर कोशिश करें।',
  'chat.emoji.retry': 'फिर कोशिश करें',
  'chat.emoji.categories': 'इमोजी की श्रेणियाँ',
  'chat.emoji.recent': 'हाल में इस्तेमाल किए',
  'chat.emoji.noRecent': 'आप जो इमोजी इस्तेमाल करेंगे, वे यहाँ दिखेंगे',
  'chat.emoji.group.0': 'स्माइली और भावनाएँ',
  'chat.emoji.group.1': 'लोग और शरीर',
  'chat.emoji.group.3': 'जानवर और प्रकृति',
  'chat.emoji.group.4': 'खाना और पीना',
  'chat.emoji.group.5': 'यात्रा और जगहें',
  'chat.emoji.group.6': 'गतिविधियाँ',
  'chat.emoji.group.7': 'चीज़ें',
  'chat.emoji.group.8': 'चिह्न',
  'chat.emoji.group.9': 'झंडे',
  'chat.emoji.results': 'खोज के नतीजे',
  'chat.emoji.skinTone': 'त्वचा का रंग',
  'chat.emoji.tone.none': 'सामान्य',
  'chat.emoji.tone.light': 'हल्का',
  'chat.emoji.tone.medium-light': 'मध्यम-हल्का',
  'chat.emoji.tone.medium': 'मध्यम',
  'chat.emoji.tone.medium-dark': 'मध्यम-गहरा',
  'chat.emoji.tone.dark': 'गहरा',
  'chat.emoji.more': 'और रिएक्शन',
  'chat.emoji.reactTitle': 'किसी भी इमोजी से रिएक्ट करें',
};
